<app-header></app-header>

<!-- Sección con fondo de imagen, fusión y logo centrado -->
<div class="bg-image-container">
  <div class="container" style="max-width: 1200px;">
    <div class="logo-container">
      <img src="/assets/logo-interbank-blanco.png" alt="Logo de la empresa" class="img-fluid">
    </div>
  </div>
</div>




<!-- Sección de Pestañas BCP-->
<section class="payment-section py-5" style="background-color: white;">
  <div class="container" style="max-width: 1200px;">
    <h2 class="text-center mb-4" style="padding-bottom: 20px;">
      <strong><span style="color: #B72727;">Selecciona</span> cómo deseas realizar tu pago</strong>
    </h2>
    <!-- Pestañas -->
    <ul class="nav nav-tabs justify-content-start" id="paymentTabs" role="tablist">
      <li class="nav-item" role="presentation">
        <button class="nav-link active d-flex align-items-center gap-2" id="mobile-tab" data-bs-toggle="tab"
          data-bs-target="#mobile" type="button" role="tab">
          <i class="fas fa-mobile-alt"></i>
          Banca Móvil
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button class="nav-link d-flex align-items-center gap-2" id="internet-tab" data-bs-toggle="tab"
          data-bs-target="#internet" type="button" role="tab">
          <i class="fas fa-laptop"></i>
          Banca por Internet
        </button>
      </li>
    </ul>

    <!-- Contenido de las pestañas -->
    <div class="tab-content mt-4" id="paymentTabsContent">
      <!-- Contenido Banca Móvil -->
      <div class="tab-pane fade show active" id="mobile" role="tabpanel">
        <div class="row align-items-center">
          <div class="col-md-4">
            <img src="assets/interbank-banca-movil.png" alt="BCP App Móvil" class="img-fluid">
          </div>
          <div class="col-md-7">
            <h5 class="fw-bold mb-4">Pasos para pagar desde
              <span style="color: #B72727;">Banca Móvil:</span>
            </h5>
            <div class="steps-container">
              <div class="step d-flex align-items-start gap-3 mb-3">
                <div class="step-number">1</div>
                <p class="mb-0">Abre la app de tu banco.</p>
              </div>
              <div class="step d-flex align-items-start gap-3 mb-3">
                <div class="step-number">2</div>
                <p class="mb-0">Ve a la opción <strong>"Servicios"</strong> .</p>
              </div>
              <div class="step d-flex align-items-start gap-3 mb-3">
                <div class="step-number">3</div>
                <p class="mb-0">Selecciona la opción<strong>"Instituciones"</strong> .</p>
              </div>
              <div class="step d-flex align-items-start gap-3 mb-3">
                <div class="step-number">4</div>
                <p class="mb-0">Busca <strong>"ITP"</strong> .</p>
              </div>
              <div class="step d-flex align-items-start gap-3 mb-3">
                <div class="step-number">5</div>
                <p class="mb-0">En <strong>"Servicio"</strong> seleccione la CITE que figura en su proforma.</p>
              </div>
              <div class="step d-flex align-items-start gap-3 mb-3">
                <div class="step-number">6</div>
                <p class="mb-0">Ingresa tu <strong>DNI</strong> o <strong>RUC</strong> y haz clic en <strong>"Buscar
                    recibos"</strong>.</p>
              </div>
              <div class="step d-flex align-items-start gap-3 mb-3">
                <div class="step-number">7</div>
                <p class="mb-0">Introduce el monto a pagar y selecciona <strong>"Cuenta de cargo"</strong> .</p>
              </div>
              <div class="step d-flex align-items-start gap-3 mb-3">
                <div class="step-number">8</div>
                <p class="mb-0">Haz clic en <strong>"Confirmar"</strong> .</p>
              </div>
              <div class="step d-flex align-items-start gap-3 mb-3">
                <div class="step-number">9</div>
                <p class="mb-0">Envía el voucher al correo indicado en tu proforma.</p>
              </div>

            </div>
          </div>
        </div>
      </div>

      <!-- Contenido Banca por Internet -->
      <div class="tab-pane fade" id="internet" role="tabpanel">
        <div class="row align-items-center">
          <div class="col-md-4">
            <img src="assets/interbank-banca-internet.png" alt="BCP App Móvil" class="img-fluid">
          </div>
          <div class="col-md-7">
            <h5 class="fw-bold mb-4">Pasos para pagar desde
              <span style="color: #B72727;">Banca por Internet:</span>
            </h5>
            <div class="steps-container">
              <div class="step d-flex align-items-start gap-3 mb-3">
                <div class="step-number">1</div>
                <p class="mb-0">Accede a la sección <strong>"Servicios"</strong>.</p>
              </div>
              <div class="step d-flex align-items-start gap-3 mb-3">
                <div class="step-number">2</div>
                <p class="mb-0">Selecciona la opción <strong>"Instituciones"</strong>.</p>
              </div>
              <div class="step d-flex align-items-start gap-3 mb-3">
                <div class="step-number">3</div>
                <p class="mb-0">Busca <strong>"ITP"</strong>.</p>
              </div>
              <div class="step d-flex align-items-start gap-3 mb-3">
                <div class="step-number">4</div>
                <p class="mb-0">En <strong>"Servicio"</strong> seleccione la CITE que figura en su proforma.</p>
              </div>
              <div class="step d-flex align-items-start gap-3 mb-3">
                <div class="step-number">5</div>
                <p class="mb-0">Ingresa tu <strong>DNI</strong> o <strong>RUC</strong> y haz clic en <strong>"Buscar
                    recibos"</strong>.</p>
              </div>
              <div class="step d-flex align-items-start gap-3 mb-3">
                <div class="step-number">5</div>
                <p class="mb-0">Introduce el monto a pagar y selecciona <strong>"Cuenta de cargo"</strong>.</p>
              </div>
              <div class="step d-flex align-items-start gap-3 mb-3">
                <div class="step-number">8</div>
                <p class="mb-0">Haz clic en <strong>"Confirmar"</strong>.</p>
              </div>
              <div class="step d-flex align-items-start gap-3 mb-3">
                <div class="step-number">9</div>
                <p class="mb-0">Envía el voucher al correo indicado en tu proforma.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>



<!-- Botón Regresar con ícono -->
<div class="container" style="padding-top: 50px; padding-bottom: 50px; display: flex; justify-content: center;">
  <a href="/" class="btn btn-warning">
    <i class="bi bi-arrow-90deg-left me-3"></i>Volver atrás</a>
</div>

<app-footer></app-footer>